{
  "cancel": "Cancel",
  "continue": "Continue",
  "save": "Save",
  "remove": "Remove",
  "retry": "Try again",
  "loading": "Loading…",
  "unknownOs": "Unknown OS",
  "signOut": "Sign out",
  "language": "Language",
  "requestId": "Request ID: {{id}}",
  "unexpected": "Something went wrong. Please try again.",
  "close": "Close"
}
